import { api, API_BASE_URL } from './client';

// Organization API
export interface Organization {
  id: string;
  name: string;
  slug: string;
  logo_url?: string;
  created_at: string;
  updated_at: string;
}

export interface OrganizationStats {
  total_users: number;
  total_teams: number;
  total_projects: number;
}

export const organizationsApi = {
  getCurrent: () =>
    api.get<{ organization: Organization; stats: OrganizationStats }>('/organizations/current'),

  updateCurrent: (data: { name?: string; slug?: string; logo_url?: string }) =>
    api.patch<{ organization: Organization }>('/organizations/current', data),

  uploadLogo: async (
    file: File,
  ): Promise<{
    message: string;
    logo_url: string;
    organization: Organization;
  }> => {
    const token = api.getToken();
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}/organizations/current/logo`, {
      method: 'POST',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error((errorData as { error?: string }).error || 'Failed to upload logo');
    }

    return response.json();
  },
};
